<div class="fixed-header"
     #header>
<!--  -->
  <div class="width-wrapper">
    <header class="landing-header">
      <a (click)="goToTop($event)"
         class="logo-link"
         href=""><h1 class="logo">ТРЭВЕЛ ОФИС<span class="logo-pro">.PRO</span></h1></a>

      <nav>
        <button class="burger"
                (click)="isMenuVisible=!isMenuVisible"
                [class.burger-active]="isMenuVisible">
          <span class="burger-name">Меню</span>
          <span class="burger-item"></span>
          <span class="burger-item"></span>
          <span class="burger-item"></span>
        </button>
        <div class="overlay"
             [class.menu-visible]="isMenuVisible"
             (click)="closeMenu($event, overlay)"
             #overlay>
          <ul class="main-nav-list">
            <li class="main-nav-item">
              <a (click)="scrollToElement($event, aboutCompanyComponent.about)"
                 [class.active]="aboutActive === activeLink"
                 class="main-nav-link text-link"
                 href="">О компании
              </a>
            </li>
            <li class="main-nav-item">
              <a (click)="scrollToElement($event, productsComponent.products)"
                 class="main-nav-link text-link"
                 [class.active]="productsActive === activeLink"
                 href="">Продукты
              </a>
            </li>
            <li class="main-nav-item">
              <a (click)="scrollToElement($event, articlesComponent.articles)"
                 class="main-nav-link text-link"
                 [class.active]="articlesActive === activeLink"
                 href="">Статьи
              </a>
            </li>
            <li class="main-nav-item">
              <a class="main-nav-link text-link"
                 (click)="scrollToElement($event, partnersComponent.partners)"
                 [class.active]="partnersActive === activeLink"
                 href="">Партнеры
              </a>
            </li>
            <li class="main-nav-item">
              <a class="main-nav-link text-link"
                 (click)="scrollToElement($event, rewardsComponent.rewards)"
                 [class.active]="rewardsActive === activeLink"
                 href="">Награды
              </a>
            </li>
            <li class="main-nav-item">
              <a class="main-nav-link text-link"
                 (click)="scrollToElement($event, footerComponent.footer)"
                 [class.active]="footerActive === activeLink"
                 href="">Контакты
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  </div>
</div>

<app-banner></app-banner>

<!--о компании-->
<div #aboutCompanyWrap>
  <app-about-company></app-about-company>
</div>

<!--продукты-->
<div #productsWrap>
  <app-products></app-products>
</div>

<!--статьи-->
<div #articlesWrap>
  <app-articles></app-articles>
</div>

<!--партнеры-->
<div #partnersWrap>
  <app-partners></app-partners>
</div>

<!--Награды-->
<div #rewardsWrap>
  <app-rewards></app-rewards>
</div>

<div #footerWrap>
  <app-footer></app-footer>
</div>

<app-cookie-warn></app-cookie-warn>
